import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ spacing }) => ({
  divider: {
    marginTop: spacing(2),
    marginBottom: spacing(2),
  },
}));
